import { boot } from 'quasar/wrappers'
import VueGtag from 'vue-gtag'

export default boot(({ app }) => {
  app.use(VueGtag, {
    disableScriptLoad: true,
    bootstrap: false
  })
})
